import { render, staticRenderFns } from "./profileTable.vue?vue&type=template&id=e5b5bdd2&"
import script from "./profileTable.vue?vue&type=script&lang=js&"
export * from "./profileTable.vue?vue&type=script&lang=js&"
import style0 from "./profileTable.vue?vue&type=style&index=0&id=e5b5bdd2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports